import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import LoadingContextProvider from './core/context/loading/loading'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { MaterialLtrTheme } from './core/context/MaterialThemContext/MaterialThemeContext'


const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <ToastContainer
        rtl={true}
        style={{
          zIndex: '1000000000',
          fontFamily: 'iransans',
          top: '0',
          width: '60%'
        }}
        className='font-iransans text-nowrap p-0 .toast-text'
        position='top-center'
        hideProgressBar={true}
      />
      <MaterialLtrTheme>
        <I18nProvider>
          <LoadingContextProvider>
            <LayoutProvider>
                <Outlet />
              <MasterInit />
            </LayoutProvider>
          </LoadingContextProvider>
        </I18nProvider>
      </MaterialLtrTheme>
    </Suspense>
  )
}

export { App }
